import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { http } from '@/lib/http';

interface HackerRankTemplate {
  id: number | string;
  name: string;
}

async function fetchHackerRankTemplates(): Promise<HackerRankTemplate[]> {
  const res = await http.get('/hacker_rank/list_interview_templates');
  return Array.isArray(res?.data) ? res.data : [];
}

export function useHackerRankTemplates(options?: { enabled?: boolean }) {
  const { data: templates = [], isLoading } = useQuery({
    queryKey: ['hackerrank', 'interview-templates'],
    queryFn: fetchHackerRankTemplates,
    staleTime: 0,
    enabled: options?.enabled ?? true,
  });

  const templateOptions = useMemo(
    () =>
      templates.length > 0
        ? templates.map((t) => ({
            value: String(t.id),
            label: t.name,
          }))
        : [],
    [templates]
  );

  return { templates, templateOptions, isLoading };
}
